import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface BusinessTypeState {
  countryOfRegistration: string
  companyRegistrationNumber: string
  businessType: string
}

const initialState: BusinessTypeState = {
  countryOfRegistration: "",
  companyRegistrationNumber: "",
  businessType: "",
}

const businessTypeSlice = createSlice({
  name: "businessType",
  initialState,
  reducers: {
    setCountryOfRegistration: (state, action: PayloadAction<string>) => {
      state.countryOfRegistration = action.payload
    },
    setCompanyRegistrationNumber: (state, action: PayloadAction<string>) => {
      state.companyRegistrationNumber = action.payload
    },
    setBusinessType: (state, action: PayloadAction<string>) => {
      state.businessType = action.payload
    },
    resetBusinessType: () => initialState,
  },
})

export const { setCountryOfRegistration , setCompanyRegistrationNumber, setBusinessType, resetBusinessType } =
  businessTypeSlice.actions

export default businessTypeSlice.reducer
